import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { Grid, Button } from '@material-ui/core';
import styled from 'styled-components';

import { modalsToggle } from '../../../../../actions';
import SectionTitle from '../../components/SectionTitle';
import { FormFormattedField } from '../../../../../components/Form';
import { SendOfferModal } from '../../../../../components/Offers';
import { ActionButton } from '../../../../../components/ActionButton';

const CounterSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > div > p {
    margin: 0;
  }
`;

const CounterComponent = ({ bid, vehicle }) => {
  const dispatch = useDispatch();

  const toggleCounterModal = () => {
    dispatch(modalsToggle(`sendVehicleOffer-${vehicle.id}`));
  };

  if (!bid.bidder) {
    return null;
  }

  return (
    <CounterSectionWrapper>
      <Grid item xs={12} sm={8}>
        <SectionTitle>{`Don't want to accept high bid from ${bid.bidder.dealership_name}?`}</SectionTitle>
      </Grid>
      <Grid item xs={12} sm={4}>
        <ActionButton onClick={toggleCounterModal} colorVariant="counter" fullWidth>
          Counter
        </ActionButton>
      </Grid>
      <SendOfferModal maxAmount={vehicle.reserve_price} form={`sendVehicleOffer-${vehicle.id}`} vehicle={vehicle} />
    </CounterSectionWrapper>
  );
};

const selector = formValueSelector('counterForm');

export default compose(
  reduxForm({
    form: 'counterForm',
    fields: ['amount']
  }),
  connect(
    state => ({
      amount: selector(state, 'amount')
    }),
    dispatch => ({
      toggleModal: modalId => dispatch(modalsToggle(modalId))
    })
  )
)(CounterComponent);
